import { CheckIcon } from '@change/ds-icons';

import { Badge } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../shared/types';

export const ResponseBadge: React.FC<{ response: NormalizedDecisionMaker['response'] }> = ({ response }) => {
	return response?.message ? (
		<Badge label="Responded" variant="success" emphasis="weaker" className="w-fit" leadingIcon={<CheckIcon />} />
	) : (
		<Badge label="Awaiting Response" variant="neutral" emphasis="weaker" className="w-fit" />
	);
};
